export default __webpack_public_path__ + "static/media/single-project-page-03-img17.12bc4397.jpg";